import React, { memo } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  IconButton,
  List,
} from '@material-ui/core';
import { Link } from '@reach/router';
import { Instagram } from '@styled-icons/boxicons-logos/Instagram';
import { FacebookBox } from '@styled-icons/remix-line/FacebookBox';
import { SocialBlogger } from '@styled-icons/foundation/SocialBlogger';
import * as Styled from './styled';
import { ReactComponent as Logo  } from '../../../assets/svgs/logo-horizontal.svg';
import { pageLinks } from '../../../shared/constants/links';
import isActiveLink from '../../../shared/helpers/isActiveLink';
import handleContractNow from '../../../shared/helpers/handleContractNow';

const MainContent = ({ handleClick, handleCloseSidebar }) => (
  <>
    <Styled.Logo to="/">
      <Logo />
    </Styled.Logo>
    <Styled.Content>
      <List component="nav" aria-label="Links para as páginas do site">
        <Styled.NavItem button disableGutters divider>
          <Link getProps={isActiveLink} to="/">HOME</Link>
        </Styled.NavItem>
        {pageLinks.map(({ route, title }, index) => (
          <Styled.NavItem button disableGutters divider key={`sidebarLink-${index.toString()}`}>
            {route.startsWith('http')
              ? <a href={route} target="_blank" rel="noopener noreferrer">{title}</a>
              : <Link getProps={isActiveLink} to={route}>{title}</Link>
            }
          </Styled.NavItem>
        ))}

        <Styled.NavItem button disableGutters divider onClick={handleClick}>
          Login
        </Styled.NavItem>

        <Styled.NavItem button disableGutters>
          <Link getProps={isActiveLink} to="/idss/">IDSS</Link>
        </Styled.NavItem>
      </List>

      <Button
        fullWidth
        color="primary"
        variant="outlined"
        size="large"
        style={{marginBottom: 10}}
        component="a"
        id="minhaWDentalLink"
        href="https://minha.w.dental"
        rel="noopener noreferrer"
      >
        2° Via de Boleto
      </Button>

      <Button
        fullWidth
        color="primary"
        variant="outlined"
        size="large"
        id="sidebarContractButton"
        onClick={() => {
          handleContractNow();
          handleCloseSidebar();
        }}
      >
        Contratar Agora
      </Button>

      <Styled.SocialLinksContainer>
        <IconButton
          component="a"
          size="small"
          color="inherit"
          aria-label="Acessar o Instagram da W.Dental"
          href="https://www.instagram.com/w.dental_br/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Instagram style={{ height: '40px', width: '40px' }} />
        </IconButton>

        <IconButton
          component="a"
          size="small"
          color="inherit"
          aria-label="Acessar o Facebook da W.Dental"
          href="https://www.facebook.com/W.Dental.br/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FacebookBox style={{ height: '40px', width: '40px' }} />
        </IconButton>

      </Styled.SocialLinksContainer>

    </Styled.Content>
  </>
);

MainContent.propTypes = {
  handleClick: PropTypes.func.isRequired,
};

export default memo(MainContent);